import { render, staticRenderFns } from "./PageCreatorsList.vue?vue&type=template&id=20004eef&scoped=true&"
import script from "./PageCreatorsList.vue?vue&type=script&lang=ts&"
export * from "./PageCreatorsList.vue?vue&type=script&lang=ts&"
import style0 from "./PageCreatorsList.vue?vue&type=style&index=0&id=20004eef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20004eef",
  null
  
)

export default component.exports